//= Structures & Data
// Own
import { TabsItemProps } from '../data/TabsItemProps';

export function TabsItem(_props: TabsItemProps) {
    return null;
}
